const CreateIcon = () => (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9705 3L10.8783 3.00465C10.4236 3.05083 10.0689 3.4348 10.0689 3.90164V10.0681L3.90155 10.0689C3.40362 10.0689 3 10.4726 3 10.9705V17.0295L3.00466 17.1217C3.05083 17.5764 3.43486 17.9312 3.90173 17.9311L10.0689 17.9297V24.0984C10.0689 24.5963 10.4725 25 10.9705 25H17.0295L17.1217 24.9953C17.5764 24.9492 17.9311 24.5652 17.9311 24.0984V17.9311H24.0984C24.5963 17.9311 25 17.5275 25 17.0295V10.9705L24.9953 10.8783C24.9492 10.4236 24.5652 10.0689 24.0984 10.0689H17.9311V3.90164C17.9311 3.40368 17.5275 3 17.0295 3H10.9705ZM16.1279 4.80328V10.9705L16.1325 11.0627C16.1787 11.5173 16.5627 11.8721 17.0295 11.8721H23.1967V16.1279H17.0295L16.9373 16.1325C16.4827 16.1787 16.1279 16.5627 16.1279 17.0295V23.1967H11.8721V17.0288L11.8675 16.9366C11.8213 16.4819 11.4373 16.1271 10.9704 16.1271L4.80328 16.1279V11.8714H10.9706L11.0628 11.8667C11.5174 11.8205 11.8721 11.4366 11.8721 10.9698V4.80328H16.1279Z"
            fill="url(#paint0_linear_5552_52177)"
        />
        <defs>
            <linearGradient
                id="paint0_linear_5552_52177"
                x1="14"
                y1="27.25"
                x2="11.625"
                y2="3.625"
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#00E6CC" />
                <stop offset="1" stopColor="#00FF99" />
            </linearGradient>
        </defs>
    </svg>
)

export default CreateIcon
